/*************************************************/
/* CARDS                                         */

import { customCursor } from "./customCursor";

/*************************************************/
export function cards() {
    const ICON_CLASS = 'card-icon';
    const MIN_SCREEN_WIDTH = 992;

    // Inline SVGs from <data-icon-url="">
    const inlineSVGIcons = () => {
        document.querySelectorAll('.icon-container').forEach(container => {
            const iconUrl = container.dataset.iconUrl;
            if (!iconUrl) return;

            fetch(iconUrl)
                .then(response => response.text())
                .then(svg => {
                    container.innerHTML = svg;
                    const svgElement = container.querySelector('svg');
                    if (svgElement) {
                        svgElement.classList.add(ICON_CLASS);
                    }
                })
                .catch(console.error);
        });
    };

    // Grid expansion behavior for cards
    const initCardGridHoverEffect = () => {
        // Only run on desktop
        if (window.matchMedia(`(min-width: ${MIN_SCREEN_WIDTH}px)`).matches) {
            document.querySelectorAll('.cards__list').forEach(list => {
                const items = Array.from(list.children); // assume <li> is grid item
                const normal = '1fr';
                const expanded = '1.5fr';

                const setColumns = (hoveredIndex = null) => {
                    const cols = items.map((_, i) => (i === hoveredIndex ? expanded : normal));
                    list.style.setProperty('--grid-template-columns', cols.join(' '));
                };

                setColumns(); // initial layout

                items.forEach((item, i) => {
                    item.addEventListener('mouseenter', () => setColumns(i));
                    item.addEventListener('mouseleave', () => setColumns());
                });
            });
        }
    };

    // Initialize everything
    const init = () => {
        inlineSVGIcons();
        initCardGridHoverEffect();
        customCursor(".card");
    };

    init();
}